import { render, staticRenderFns } from "./GmbLabelsDeleteDialog.vue?vue&type=template&id=2e417338&scoped=true&"
import script from "./GmbLabelsDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./GmbLabelsDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./GmbLabelsDeleteDialog.vue?vue&type=style&index=0&id=2e417338&lang=scss&scoped=true&"
import style1 from "./GmbLabelsDeleteDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e417338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VTextField,VVirtualScroll})
